// not guaranteed to be unique, but good enough for app stuff and very fast
// eslint-disable-next-line
export const getId = (): string => ('$' + (Math.random() * 0xFFFFFF << 0).toString(16));
